import { TARGET } from "drop-in-ui/utils/configs";
import { isLocal } from "drop-in-ui/utils/is-local";

/**
 * Generates a version based on NPM package, target and Version ENV (git sha)
 */

let version;

try {
  version = APP_VERSION;
} catch (e) {
  version = "0.0.0";
}

export const VERSION = isLocal()
  ? "c7-local"
  : [version, "-", TARGET, "-", COMMIT_HASH].join("");
